import DOMPurify from 'dompurify';

// Server-side safety note: In SSR environment ensure JSDOM or skip.
export function sanitizeHtml(input: string): string {
  if (!input) return '';
  try {
    return DOMPurify.sanitize(input, {
      USE_PROFILES: { html: true },
      ALLOWED_ATTR: ['src', 'href', 'target', 'rel', 'alt', 'title', 'class', 'id'],
    });
  } catch {
    // fallback minimal strip
    return input.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
      .replace(/on[a-z]+\s*=\s*"[^"]*"/gi, '')
      .replace(/on[a-z]+\s*=\s*'[^']*'/gi, '')
      .replace(/on[a-z]+\s*=\s*[^\s>]+/gi, '');
  }
}
